import axios from 'axios';

export const User = {
  // Dodajemy tę linię, aby akcje i mutacje były wywoływane z prefiksem 'user/'
  namespaced: true,

  state: {
    user: {
      id: 0,
      name: '',
      surname: ''
    },
    isLoggedIn: false
  },
  mutations: {
    // Ta mutacja jest trochę niebezpieczna, lepiej użyć setUser
    // Zostawiamy ją, bo może być używana gdzieś indziej
    setLoggedIn(state, value) {
      state.isLoggedIn = value;
    },
    // Poprawiona mutacja setUser
    setUser(state, user) {
      state.user = user;
      state.isLoggedIn = true;
    },
    // Poprawiona mutacja logoutUser
    logoutUser(state) {
      state.user = { id: 0, name: '', surname: '' };
      state.isLoggedIn = false;
    }
  },
  
  // NOWY, DODANY BLOK 'ACTIONS'
  actions: {
    /**
     * Ta akcja jest wywoływana przy starcie aplikacji.
     * Wysyła zapytanie do /api/user. Jeśli serwer odpowie sukcesem (200),
     * oznacza to, że użytkownik ma ważną sesję w ciasteczku.
     * Wtedy zapisujemy dane użytkownika do store.
     * Jeśli serwer odpowie błędem (np. 401), czyścimy dane użytkownika.
     * Ta akcja zawsze resolve(), nigdy nie reject(), aby nie przerywać ładowania aplikacji.
     */
    checkAuth({ commit }) {
      return new Promise((resolve) => {
        axios.get('/api/user')
          .then(response => {
            // Sukces: użytkownik jest zalogowany
            commit('setUser', response.data);
            resolve(response);
          })
          .catch(error => {
            // Błąd: użytkownik nie jest zalogowany
            commit('logoutUser');
            // Resolv zamiast reject - aplikacja powinna normalnie załadować się nawet bez użytkownika
            resolve(error);
          });
      });
    }
  },
  
  getters: {
    getUser(state) {
      return state.user;
    },
    currentUserID(state) {
      return state.user.id;
    },
    getUserName(state) {
      return state.user.name + ' ' + (state.user.surname || '');
    },
    userRole(state) {
      return state.user.type;
    },
    isLoggedIn(state) {
      return state.isLoggedIn;
    }
  }
};

export default User;